module.exports = __webpack_public_path__ + "img/truck-medical.fdbabb4c.svg";